import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useCallback,
} from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  CircularProgress,
  LinearProgress,
  Fade,
  Box,
} from "@mui/material";
import ReactPaginate from "react-paginate";
import Table from "../../Components/Common/Table/Table";
import {
  getInfoMessageNoResultsSearch,
  CommonSubHeader,
} from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import TableActions from "../../Components/Common/Table/TableActions";
import {
  SettingsAccessibility,
  TransferWithinAStation,
} from "@mui/icons-material";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

function UserTpes({ flagToShow = true }) {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [pagePressed, setPagePressed] = useState(1);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [flag, setFlag] = useState(false);
  const [changeDone, setChangeDone] = useState(false);

  const [roleList, setRoleList] = useState([]);

  const [filters, setFilters] = useState({
    type: 0,
    user_level: 0,
  });

  const [options, setOptions] = useState({
    type: [],
    user_level: [],
  });

  const [loadingOptions, setLoadingOptions] = useState({
    type: false,
    user_level: false,
  });

  const rolesData = async () => {
    setFlag(true);
    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + "/roles",
        {
          page: pagePressed,
          objPerPage,
          ...filters,
        },
      );

      console.log(response);

      const { user_types, status, roles: rolesList } = response.data;

      setRoleList(rolesList);

      const type = roles?.map((role) => ({ type: role.type }));

      // Crear un Set para obtener valores únicos
      const user_levelSet = new Set(roles?.map((role) => role.user_level));
      const user_level = Array.from(user_levelSet).map((level) => ({
        user_level: level,
      }));

      // Ordenar user_level
      user_level.sort((a, b) => a.user_level - b.user_level);

      if (user_types?.total === 0) {
        return Swal.fire({
          icon: "error",
          title: "No se encontraron resultados",
          text: "Modifica tu búsqueda",
        });
      }

      setRoles(user_types?.data);
      setPageCount(user_types?.last_page);
      setTotalPagesNumber(user_types?.total);
      setOptions((prev) => ({ ...prev, type, user_level }));
    } catch (error) {
      console.error("Error fetching roles:", error);

      const errorStatus = error?.response?.statusText == "Forbidden";

      const errorLog = errorStatus
        ? "No estás autorizado para entrar a esta sección."
        : "Error en el servidor.";

      Swal.fire({
        icon: "error",
        title: errorLog,
        text: "Hubo un problema al cargar los datos.",
        allowEscapeKey: !errorLog,
        allowOutsideClick: !errorLog,
      }).then((event) => {
        if (errorLog && event.isConfirmed) {
          navigate("/");
        }
      });
    } finally {
      setFlag(false);
    }
  };

  useEffect(() => {
    rolesData();
  }, [pagePressed, objPerPage, filters, changeDone]);

  const handlePageClick = (event) => setPagePressed(event.selected + 1);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    if (name === "objPerPage") {
      setObjPerPage(value > totalPagesNumber ? totalPagesNumber : value);
    }
  };

  const renderCellWithDefault = (value, center) => {
    return (
      <div
        className={"spanClassForTables " + (center ? "centerContent" : "")}
        style={!center ? { paddingLeft: "10px" } : {}}>
        {value}
      </div>
    );
  };

  const columns = [
    {
      Header: "LISTA DE ROLES DE EMPRESA",
      columns: [
        {
          Header: "Tipo de Usuario",
          accessor: "type",
          width: 400,
          Cell: ({ value }) => renderCellWithDefault(value),
        },
        // {
        //   Header: "Nivel",
        //   accessor: "user_level",
        //   width: 150,
        //   Cell: ({ value }) => renderCellWithDefault(value, true),
        // },
        {
          Header: "Acciones",
          accessor: "id",
          width: 50,
          Cell: ({ value }) => (
            <TableActions
              rute={"roles"}
              showEdit
              module={"userstypes"}
              // showView
              apiRute="roles"
              roleFlag
              roles={roleList}
              value={value}
              showDelete
              setChangeDone={setChangeDone}
              changeDone={changeDone}
            />
          ),
        },
      ],
    },
  ];

  const fieldsConfig = [
    {
      type: "autocomplete",
      label: "Niveles",
      options: options.user_level || [], // Asegura que sea un array
      loading: loadingOptions.user_level,
      onChange: (_, value) =>
        handleFilterChange("user_level", value ? value.user_level : 0), // Manejar el caso cuando value es null
      getOptionLabel: (option) =>
        option.user_level ? option.user_level.toString() : "", // Asegúrate de que sea una cadena
    },
  ];

  const renderField = (field, index) => (
    <Grid
      item
      xs={4}
      md={2}
      key={index}
      textAlign="left"
      sx={{ padding: "5px" }}>
      <Autocomplete
        size="small"
        className={field.className}
        options={field.options || []} // Asegura que sea un array
        loading={field.loading}
        onChange={field.onChange}
        getOptionLabel={field.getOptionLabel}
        renderInput={(params) => (
          <TextField
            {...params}
            label={field.label}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {field.loading && (
                    <CircularProgress color="inherit" size={20} />
                  )}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  const content = (
    <div>
      {flagToShow ? (
        <CommonSubHeader title="Configuración" subTitle="Roles" />
      ) : null}

      <div className="fatherContainer">
        <div className="mainContainer">
          <div className="subMainContainer">
            <Grid
              container
              direction="row"
              m={"10px 0"}
              item
              xs={12}
              className="filtersContainer">
              {fieldsConfig.map(renderField)}
            </Grid>
            <Fade in timeout={800}>
              <div>
                {(roles === "" || flag) && (
                  <LoadingPage isLoading={flag} heightProp={"60vh"} />
                )}
                {roles && !flag && (
                  <>
                    <Table
                      columns={columns}
                      data={roles}
                      view={"rol"}
                      viewTitle={"roles"}
                      totalPagesNumber={totalPagesNumber}
                      tableWidth={"unset"}
                      minTableWidth={"50%"}
                      icon={SettingsAccessibility}
                    />
                    {totalPagesNumber > 10 && (
                      <div className="tablePaginateContainer">
                        <div className="paginatorLeftText">
                          Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                          {Math.min(objPerPage * pagePressed, totalPagesNumber)}{" "}
                          de {totalPagesNumber} resultados
                        </div>
                        <ReactPaginate
                          breakLabel="..."
                          nextLabel="Siguiente 🢂"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={2}
                          pageCount={pageCount}
                          previousLabel="🢀 Anterior"
                          containerClassName="pagination"
                          activeClassName="active"
                          pageClassName="page-item"
                          nextClassName="page-item"
                          previousClassName="page-item"
                          disabledClassName="disabled"
                          forcePage={pagePressed - 1}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );

  return <>{content}</>;
}

export default UserTpes;
